export default __webpack_public_path__ + "static/media/lion-2.c5f1c15c.png";